export default __webpack_public_path__ + "static/media/global.1ba447b5.svg";